export enum SubscriptionLevel {
    Free = 0,
    Basic = 1,
    BasicPlus = 2,
    BasicAdvanced = 3,
    Premium = 4,
    Enterprise = 5
}